const nodeFetch = async (url) => {
  const fs = require("fs").promises;
  const path = require("path");
  const filePath = path.join("public", url);
  const data = await fs.readFile(filePath, "utf8");
  return {
    json: () => JSON.parse(data),
    text: () => data
  };
};
const sharedFetch = typeof window === "undefined" ? nodeFetch : fetch;
export {
  sharedFetch as default
};
//# sourceMappingURL=sharedFetch.js.map
